export const stringIsValidNumber = (value: string, integerOnly: boolean, min?: number, max?: number): boolean => {
  const hasDecimal = value.indexOf(".") !== -1;
  const hasLetters = value.toLowerCase().search("[a-zA-Z]") !== -1;
  const asFloat = parseFloat(value);
  const isInteger = asFloat % 1 === 0;
  if (hasLetters || isNaN(asFloat)) {
    return false;
  }
  if (integerOnly && (hasDecimal || !isInteger)) {
    return false;
  }
  if (min && max && (asFloat > max || asFloat < min)) {
    return false;
  }
  return true;
};

export function assertNever<A>(value: never): A {
  throw new Error("Unexpected value", value);
}
